var _defs, _path, _tspan, _tspan2, _tspan3, _tspan4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdGlogotransparent1Optimized(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lag_1",
    "data-name": "Lag 1",
    viewBox: "0 0 328.266 78.287",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs65"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style63"
  }, "\n            .cls-2{fill:none;stroke-miterlimit:10;stroke-width:3px;stroke:#70ad47}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M184.995 177.701a37.644 37.644 0 1 1 .052-40.778",
    transform: "translate(-114.234 -118.127)",
    id: "path79"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M248.642 179.067a37.644 37.644 0 1 1 .11-43.435",
    transform: "translate(-114.234 -118.127)",
    id: "path81",
    style: {
      stroke: "#4472c4",
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.735 179.537a37.644 37.644 0 1 1-.188-44.786",
    transform: "translate(-114.234 -118.127)",
    id: "path83",
    style: {
      stroke: "#9dc3e6",
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.928 179.706a37.644 37.644 0 1 1 .163-44.648",
    transform: "translate(-114.234 -118.127)",
    id: "path85",
    style: {
      stroke: "#bdd7ee",
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 289.123,
    cy: 39.144,
    r: 37.644,
    id: "circle87",
    style: {
      display: "inline"
    }
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fill: "#fff"
    },
    x: 84.888,
    y: 54.322,
    id: "text456"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan454",
    x: 84.888,
    y: 54.322,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 48,
      fontFamily: "sans-serif",
      InkscapeFontSpecification: "'sans-serif, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      fill: "#fff"
    }
  }, "O")), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    d: "m39.19.282-.282 77.815",
    id: "path573"
  }), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 48,
      fontFamily: "sans-serif",
      InkscapeFontSpecification: "'sans-serif, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      fill: "#fff"
    },
    x: 23.269,
    y: 54.322,
    id: "text577"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan575",
    x: 23.269,
    y: 54.322
  }, "P"))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 48,
      fontFamily: "sans-serif",
      InkscapeFontSpecification: "'sans-serif, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      fill: "#fff"
    },
    x: 141.34,
    y: 54.322,
    id: "text581"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan579",
    x: 141.34,
    y: 54.322
  }, "W"))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 48,
      fontFamily: "sans-serif",
      InkscapeFontSpecification: "'sans-serif, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      fill: "#fff"
    },
    x: 210.186,
    y: 54.322,
    id: "text585"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan583",
    x: 210.186,
    y: 54.322
  }, "E"))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: 400,
      fontStretch: "normal",
      fontSize: 48,
      fontFamily: "sans-serif",
      InkscapeFontSpecification: "'sans-serif, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontVariantEastAsian: "normal",
      fill: "#fff"
    },
    x: 271.622,
    y: 54.322,
    id: "text589"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan587",
    x: 271.622,
    y: 54.322
  }, "R"))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdGlogotransparent1Optimized);
export default __webpack_public_path__ + "static/media/PDGlogo.transparent.1-optimized.0b4e3eea5d6be4ba46c2725e20807d9c.svg";
export { ForwardRef as ReactComponent };